import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';

class OccasionalSalaryRow extends Component {
    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Sorszám</TableCell>
                            <TableCell>Munkavállaló</TableCell>
                            <TableCell>Dátum</TableCell>
                            <TableCell>Összeg</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell>{this.props.row.publicId}</TableCell>
                            <TableCell>{this.props.row.name}</TableCell>
                            <TableCell>{this.props.row.date}</TableCell>
                            <TableCell>{this.props.row.amount}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default OccasionalSalaryRow;